import React, { useEffect } from 'react';
import { Box, IconButton, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const DynamicGalleryModal = ({ gallery, selectedIndex, open, onClose, onPrevious, onNext }) => {
  const isFirst = selectedIndex === 0;
  const isLast = selectedIndex === gallery.length - 1;

  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft' && !isFirst) onPrevious();
      if (e.key === 'ArrowRight' && !isLast) onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, selectedIndex, isFirst, isLast, onClose, onPrevious, onNext]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 6000,
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0,0,0,0.85)'
        }
      }}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          outline: 'none',
          width: { xs: '90vw', sm: '80vw', md: '70vw', lg: '60vw' },
          maxWidth: '1000px',
          maxHeight: '90vh'
        }}>
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: { xs: -45, sm: -50 },
            right: { xs: 0, sm: -10 },
            color: '#fff',
            backgroundColor: 'rgba(255,255,255,0.15)',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' },
            zIndex: 1
          }}>
          <CloseIcon />
        </IconButton>

        {/* Previous Button */}
        <IconButton
          onClick={onPrevious}
          disabled={isFirst}
          sx={{
            position: 'absolute',
            left: { xs: 10, sm: -55, md: -60 },
            color: '#fff',
            backgroundColor: 'rgba(255,255,255,0.15)',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' },
            '&.Mui-disabled': { opacity: 0.3, color: '#fff' },
            zIndex: 1
          }}>
          <ArrowBackIosNewIcon />
        </IconButton>

        {/* Image */}
        <Box
          component="img"
          src={gallery[selectedIndex]}
          alt={`Gallery image ${selectedIndex + 1}`}
          sx={{
            width: '100%',
            maxHeight: '80vh',
            objectFit: 'contain',
            borderRadius: '10px'
          }}
        />

        {/* Next Button */}
        <IconButton
          onClick={onNext}
          disabled={isLast}
          sx={{
            position: 'absolute',
            right: { xs: 10, sm: -55, md: -60 },
            color: '#fff',
            backgroundColor: 'rgba(255,255,255,0.15)',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' },
            '&.Mui-disabled': { opacity: 0.3, color: '#fff' },
            zIndex: 1
          }}>
          <ArrowForwardIosIcon />
        </IconButton>

        {/* Image Counter */}
        <Box
          sx={{
            position: 'absolute',
            bottom: { xs: -35, sm: -40 },
            left: '50%',
            transform: 'translateX(-50%)',
            color: '#fff',
            fontFamily: 'gothamBook',
            fontSize: '14px'
          }}>
          {selectedIndex + 1} / {gallery.length}
        </Box>
      </Box>
    </Modal>
  );
};

export default DynamicGalleryModal;
